import { useEffect, useState } from "react";
import { getConsent, setConsent } from "@/lib/analytics";

/**
 * Banner de consentimento (LGPD). Enquanto a pessoa não escolhe, o Consent
 * Mode fica em "denied" e o GA4/Ads não gravam cookies nem enviam dados.
 */
export function ConsentBanner() {
  const [show, setShow] = useState(false);

  useEffect(() => {
    if (getConsent() === null) setShow(true);
  }, []);

  if (!show) return null;

  const choose = (state: "granted" | "denied") => {
    setConsent(state);
    setShow(false);
  };

  return (
    <div className="fixed inset-x-0 bottom-0 z-[60] p-3 sm:p-4">
      <div className="mx-auto flex max-w-3xl flex-col gap-3 rounded-2xl border border-border bg-card/95 p-4 text-sm shadow-2xl backdrop-blur sm:flex-row sm:items-center sm:gap-4">
        <p className="flex-1 text-muted-foreground">
          Usamos cookies para medir a audiência do site e melhorar nossos anúncios. Você pode
          aceitar ou recusar.{" "}
          <a
            href="/politica-de-privacidade"
            className="font-semibold text-primary underline-offset-2 hover:underline"
          >
            Política de Privacidade
          </a>
        </p>
        <div className="flex shrink-0 gap-2">
          <button
            type="button"
            onClick={() => choose("denied")}
            className="rounded-lg border border-input px-4 py-2 font-semibold text-foreground transition hover:bg-accent"
          >
            Recusar
          </button>
          <button
            type="button"
            onClick={() => choose("granted")}
            className="rounded-lg bg-primary px-4 py-2 font-extrabold uppercase tracking-wide text-primary-foreground transition hover:brightness-110"
          >
            Aceitar
          </button>
        </div>
      </div>
    </div>
  );
}
